import React, { useState, useEffect } from "react";
import { Button, Card, Dropdown, Modal, Space, Tag } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { HiOutlineChevronDown } from "react-icons/hi";
import { MdOutlineDynamicForm } from "react-icons/md";
import AppControl from "../../components";
import { getFormElements, deleteFormElement } from "../../store/slice/formElements";

function FormElements() {
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [modalText, setModalText] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFormElements());
  }, []);

  const formElementsList = useSelector((state) => state.formElements.list);

  const showDeleteConfirm = (row) => {
    setModalText(`Are you sure you want to delete "${row.formName}"?`);
    setOpen(true);
    setDeleteId(row.id);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    const resultAction = await dispatch(deleteFormElement(deleteId));
    if (deleteFormElement.fulfilled.match(resultAction)) {
      setOpen(false);
      setConfirmLoading(false);
      dispatch(getFormElements());
      Modal.success({ content: resultAction.payload.message });
    } else {
      setOpen(false);
      setConfirmLoading(false);
      Modal.error({ content: resultAction.error.message });
    }
  };

  const handleCancel = () => setOpen(false);

  const COLUMNS = [
    {
      Header: "Id",
      accessor: "id",
      isVisible: false,
      disableFilters: true,
    },
    {
      Header: "Application",
      accessor: "applicationName",
      disableFilters: true,
    },
    {
      Header: "Form Name",
      accessor: "formName",
      disableFilters: true,
    },
    {
      Header: "Fields",
      accessor: "fields",
      disableFilters: true,
      Cell: ({ value }) => (
        <Tag color="blue">{Array.isArray(value) ? value.length : 0} fields</Tag>
      ),
    },
    {
      Header: "Actions",
      disableFilters: true,
      Cell: ({ row }) => (
        <Dropdown
          menu={{
            items: [
              {
                key: "1",
                label: <Link to={`edit/${row.values.id}`}>Edit</Link>,
              },
              {
                key: "2",
                danger: true,
                label: (
                  <span onClick={() => showDeleteConfirm(row.values)}>
                    Delete
                  </span>
                ),
              },
            ],
          }}
        >
          <Button>
            <Space>
              Actions <HiOutlineChevronDown />
            </Space>
          </Button>
        </Dropdown>
      ),
    },
  ];

  return (
    <Card
      title="FORM ELEMENTS"
      extra={
        <AppControl
          control="button"
          type="button"
          name="Add Form Element"
          size="full"
          color="orange"
          icon={<MdOutlineDynamicForm className="inline mr-2" />}
          onClick={() => navigate("/form-elements/add")}
        />
      }
    >
      <AppControl
        control="table"
        columns={COLUMNS}
        data={Array.isArray(formElementsList) ? formElementsList : []}
      />
      <Modal
        title="Delete Form Element"
        open={open}
        okText="Yes, Delete!"
        okType="danger"
        onOk={handleOk}
        confirmLoading={confirmLoading}
        cancelText="No, Cancel"
        onCancel={handleCancel}
      >
        <p>{modalText}</p>
      </Modal>
    </Card>
  );
}

export default FormElements;
